import { render, staticRenderFns } from "./practicalDetail.vue?vue&type=template&id=8a8caee8&scoped=true&"
import script from "./practicalDetail.vue?vue&type=script&lang=js&"
export * from "./practicalDetail.vue?vue&type=script&lang=js&"
import style0 from "./practicalDetail.vue?vue&type=style&index=0&id=8a8caee8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8caee8",
  null
  
)

export default component.exports